import { render } from "./Tab.vue?vue&type=template&id=f5783734&scoped=true"
import script from "./Tab.vue?vue&type=script&lang=js"
export * from "./Tab.vue?vue&type=script&lang=js"

import "./Tab.vue?vue&type=style&index=0&id=f5783734&scoped=true&lang=scss"

import exportComponent from "C:\\Users\\kevin.chang\\Documents\\hzn\\oversea-website\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f5783734"]])

export default __exports__